<template>
    <div class="toolbar-container">
        <div class="merge-field-dropdown-container">
            <MergeFieldDropdown
                ref="mergeFieldDropdown"
                v-click-outside="() => isMergeFieldDropdownOpen = false"
                class="merge-field-dropdown"
                data-qa="merge-field-dropdown"
                :use-merge-service="useMergeService"
                :merge-field-categories="mergeFieldCategories"
                :is-open="isMergeFieldDropdownOpen"
                @select="mergeFieldSelected"
                @click.native.capture="mergeFieldDropdownClick"
            >
                <template #action>
                    <DsTooltip position="top" class="tooltip-container">
                        <template #reference>
                            <DsIconButton
                                name="merge-field"
                                :aria-label="$t('components.shared.mergeFieldDropdown.tooltip')"
                                data-qa="mergeable-input-button"
                                @mousedown.prevent
                                @click="handleMergeFieldIconClicked"
                            />
                        </template>

                        <template #default>
                            <span>{{ $t('components.shared.mergeFieldDropdown.tooltip') }}</span>
                        </template>
                    </DsTooltip>
                </template>
            </MergeFieldDropdown>
        </div>

        <div class="emoji-picker-container">
            <DsTooltip position="top" class="tooltip-container">
                <template #reference>
                    <DsIconButton
                        name="emoji"
                        @click.stop="toggleEmojiPicker"
                    />
                </template>

                <template #default>
                    <span>{{ $t('components.shared.advancedInput.emojiPickerTooltip') }}</span>
                </template>
            </DsTooltip>

            <div
                v-show="showEmojiPicker"
                ref="emojiPickerContainer"
                v-click-outside="() => showEmojiPicker = false"
                class="emoji-picker"
            >
                <EmojiPicker
                    data-qa="emoji-picker"
                    @select="emojiSelected"
                    @click.native.stop
                />
            </div>
        </div>
    </div>
</template>

<script>
import EmojiPicker from '@/components/shared/EmojiPicker.vue';
import MergeFieldDropdown from '@/components/shared/MergeFieldDropdown.vue';

export default {
    name: 'InputToolbar',

    components: { EmojiPicker, MergeFieldDropdown },

    props: {
        mergeFieldCategories: {
            type: Array,
            default: () => [],
        },
        useMergeService: Boolean,
        insertTextIntoInput: {
            required: true,
            type: Function,
        },
    },

    data() {
        return {
            showEmojiPicker: false,
            isMergeFieldDropdownOpen: false,
        };
    },

    methods: {
        mergeFieldSelected({ value }) {
            this.insertTextIntoInput(value);

            this.isMergeFieldDropdownOpen = false;
        },

        emojiSelected({ native }) {
            this.insertTextIntoInput(native);
        },

        handleMergeFieldIconClicked() {
            if (this.showEmojiPicker) {
                this.showEmojiPicker = false;
            }

            this.isMergeFieldDropdownOpen = !this.isMergeFieldDropdownOpen;
        },

        async toggleEmojiPicker() {
            this.showEmojiPicker = !this.showEmojiPicker;

            if (this.isMergeFieldDropdownOpen) {
                this.isMergeFieldDropdownOpen = false;
            }

            await this.$nextTick();

            /* we need the click event (that triggered this function) to bubble
            but we cannot use @click.stop because the v-click-outside on
            the emoji picker container will close it instantly otherwise. So we
            trigger another click event on the emoji picker container which will bubble */
            this.$refs.emojiPickerContainer.click();
        },

        mergeFieldDropdownClick() {
            this.$refs.mergeFieldDropdown.$el.click();
        },
    },
};
</script>

<style lang="scss" scoped>
.toolbar-container {
    width: 100%;
    display: flex;
}

.emoji-picker-container {
    position: relative;
}

.emoji-picker {
    display: flex;
    position: absolute;
    top: var(--emoji-picker-top, 50px);
    z-index: 10;
}
</style>
